import React from "react";
import { motion } from "framer-motion";

import Icon from "./ui/Image";
import List from "./ui/List";
import Button from "./ui/Button";
import { LightText3 } from "./ui/Text";
import CustomLink from "./ui/CustomLink";
import { Center } from "./css";
import { Link } from "@/types/global";

interface SignUpCardProps {
  icon: string;
  name: string;
  description?: string;
  info: string[];
  buttonText: string;
  isActive?: boolean;
  onCLickHandler: () => void;
  bottomContent: { text: string; link: Link };
}

const SignUpCard: React.FC<SignUpCardProps> = ({ icon, name, info, onCLickHandler, buttonText, bottomContent, description, isActive }) => {
  return (
    <motion.div
      className="rounded-xl border border-borderColor1 bg-white md:w-[299px] flex justify-center items-center flex-col p-4 relative"
      style={{
        perspective: 2000,
      }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <motion.div
        className="p-5 bg-[#F6EFFF] rounded-full absolute -top-[50px]"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <Icon src={icon} alt="icon" className="size-[60px]" />
      </motion.div>
      <motion.div
        className="w-full h-full flex flex-col justify-between"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <h2 className="text-center font-semibold text-base md:text-2xl pb-3 mt-[50px] text-text-label">{name}</h2>
        {description && <h6 className="text-10 md:text-13 text-text-label leading-normal px-2">{description}</h6>}
        <List items={info} variant="bullet" className="!text-text-label py-4" itemClassName="text-10 md:text-13 text-text-label" />
        <div>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              variant="primary"
              className={isActive ? "" : "!bg-[#6F36BC05] !text-text-primary !text-13 md:!text-lg !font-bold !opacity-100"}
              isFullWidth
              onClick={onCLickHandler}
              disabled={!isActive}
            >
              {buttonText}
            </Button>
          </motion.div>
          <Center>
            <div className="border-t border-borderColor1 md:mt-3 md:pt-1 text-center w-fit">
              <LightText3 text={bottomContent.text} className="!text-10 md:!text-13" />
              <CustomLink link={bottomContent.link} className="font-normal !leading-5 !text-10 md:!text-13" disabled={!isActive} />
            </div>
          </Center>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SignUpCard;
